import { Observable, Subject } from 'rxjs'
import { LogEvent } from 'src/app/interfaces/log'
import { GeneralService } from 'src/app/services/general/general.service'
import { LogService } from '../log/log.service'

declare const window: any

export class DeeplinkService {
  private _deeplinkPath: string | undefined
  private deeplinkPathSubject = new Subject<string | undefined>()
  private _webBranchSdkInitialized = false
  private branchInitializeSubject = new Subject<boolean>()

  constructor(private generalService: GeneralService, private logService: LogService) {}

  get deeplinkPath(): string | undefined {
    const path = this._deeplinkPath
    return path
  }

  set deeplinkPath(path: string | undefined) {
    this._deeplinkPath = path
    this.deeplinkPathChanged(path)
  }

  get webBranchSdkInitialized(): boolean {
    return this._webBranchSdkInitialized
  }

  getBranchInitializeSubject(): Observable<boolean> {
    return this.branchInitializeSubject.asObservable()
  }
  webBranchInitialized(initialized: boolean): void {
    this._webBranchSdkInitialized = initialized
    this.branchInitializeSubject.next(initialized)
  }

  deeplinkPathChanged(path: string | undefined): void {
    this.deeplinkPathSubject.next(path)
  }

  getDeeplinkPathSubject(): Observable<string | undefined> {
    return this.deeplinkPathSubject.asObservable()
  }

  initializeDeeplinkPath(): void {
    this.deeplinkPath = undefined
  }

  openApp(pathname: string, buttonType?: string): void {
    const url: URL = new URL(window.location.href)
    this.logService.eventLogging(LogEvent.WEB_OPEN_WITH_APP_BUTTON_CLICKED, {
      button_type: buttonType,
      from: url.pathname,
    })
    const appLink = `https://link.types.my${pathname.startsWith('/') ? pathname : `/${pathname}`}`
    this.generalService.openInappBrowser(appLink)
  }
}
